<script setup>
definePageMeta({
  key: route => route.fullPath,
  middleware: 'auth'
})

await Promise.all([usePageLocales(), useSsrHomePage()])

useCustomMeta()
</script>

<template>
  <div class="homepage bg-ui-colourful-100">
    <!-- <LazyHomeReview /> -->
    <LazyHomeWelcome class="desktop:mb-[96px] mb-[200px]" />
    <LazyHomeSupplier />
    <LazyHomeCampaign />
    <LazyHomeWhyUs />
    <LazyHomeLocation class="mobile:!p-0 tablet:!p-0" />
    <LazyHomeOtherRentLocation />
    <LazyHomeFaqs />
    <LazyHomeAppBanner />
    <LazyHomeSeoContent />
    <!-- <LazySubscriber /> -->
  </div>
</template>

<style lang="scss">
.homepage section {
  @apply px-4;

  & div:first-child {
    @apply max-w-[1440px];
  }
}
</style>
